module.exports = __webpack_public_path__ + "static/media/mapiq-active.fe9de0e3.svg";